import React from 'react';
import {Badge, BadgeProps} from './GenericBadges';
import {badgeColors} from './badgeColors';

/**
 * The CAMPAIGN_SALE badge applies the BE `Badge.CampaignSale.colors`
 * foreground (threaded through by `BadgeList`), falling back to white text;
 * the background comes from the BE campaign colour. See ASFE-14225.
 */
export const CampaignSaleBadge = (props: BadgeProps) => (
  <Badge {...props} textColor={props.textColor || badgeColors.colors.sale} />
);
